import * as z from "zod";

const SeededEmailMessageSchema_ = z.object({
  senderName: z.string().nullable(),
  senderEmail: z.string().nullable(),
  /** ISO 8601. */
  sentAt: z.string().nullable(),
  /** The email's own paragraphs; a paragraph keeps its line breaks as `\n`. */
  paragraphs: z.array(z.string()),
  /** Quoted history ("On … wrote:"), split from `paragraphs`. */
  quotedParagraphs: z.array(z.string()),
  attachmentNames: z.array(z.string()),
});
export interface SeededEmailMessage extends z.infer<
  typeof SeededEmailMessageSchema_
> {}

const SeededEmailSchema_ = z.object({
  messageId: z.string(),
  subject: z.string().nullable(),
  messages: z.array(SeededEmailMessageSchema_),
});
/** The email a chat was created from, drawn as a card in place of the chat message `messageId`. */
export interface SeededEmail extends z.infer<typeof SeededEmailSchema_> {}
export const SeededEmailSchema: z.ZodType<SeededEmail> = SeededEmailSchema_;
